export enum TransactionDigitalWalletCode {
  Apple = 'APPLE_PAY',
  Google = 'GOOGLE_PAY'
}
